import { SET_WEBISTE_LANGUAGE } from "../Actions/languageActions";

const INITIAL_STATE = {
  language: null,
};

export const languageReducer = (state = INITIAL_STATE, action) => {
  const { payload } = action;
  switch (action.type) {
    case SET_WEBISTE_LANGUAGE: {
      return {
        ...state,
        language: payload.language,
      };
    }
    default:
      return state;
  }
};

export default languageReducer;
